/**
 * SignOut Store - State management for sign out action
 *
 * This store handles user sign out, including token cleanup for iframe scenarios.
 */

import { atom } from 'jotai'
import { authClient } from '../client'
import { currentUserQueryAtom } from '../currentUser'
import { tokenStorage, inIframe } from 'txom-frontend-libs'
import { getAuthStateChangedHandler$ } from 'txom-frontend-libs'
import { resetQueryClient } from '../../queryClient'

// ============================================================================
// ACTIONS
// ============================================================================

// Sign out action atom
export const signOutAtom = atom(null, async (get, set) => {
  const currentUser = get(currentUserQueryAtom).data
  if (!currentUser) return // Not logged in, nothing to do

  if (inIframe) {
    tokenStorage.remove()
  }
  await authClient.signOut()

  const handler = get(getAuthStateChangedHandler$)
  if (handler) {
    handler(false)
  }

  // Clear all query cache to ensure user state is reset
  set(resetQueryClient)
})
